export const getHighlitedResultIndex = (teamScoresLength, decrease) => Math.max(Math.min(teamScoresLength - decrease, teamScoresLength), 0);
//# sourceMappingURL=getHighlitedResultIndex.js.map